import { ChangeDetectionStrategy, Component } from '@angular/core';

// The Segment/Tab Tests card's body on the Test UI Components page: text-only tabs and tabs with
// icons (as on the Foods page), with the selected values shown below.
@Component({
  selector: 'cs-test-tabs-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-tabs-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestTabsCardComponent {
  selectedTab = 'tab1';
  selectedIconTab = 'foods';
}
